
import _ from 'lodash';
import React, { useState, useEffect } from "react";
import axios from "axios";
import useList from "core/useList";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import UploadButton from "../../../form/UploadButton";
import {FileLink} from "../../../common/FileLink";
import {DateTimeDisplay} from "../../../core/Display";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import styled from "styled-components";
import {grey, red} from "@material-ui/core/colors";


const StyledGroup = styled.div`
  margin-bottom: 20px;
  
  h3 {
    margin: 0;
    padding: 0;
    cursor: pointer;
    font-size: 14px;
    
    display: flex;
    align-items: center;
  }
`;

const StyledUploadedDocumentItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
  grid-gap: 10px;
  margin-top: 15px;
  
  .name {
    margin-bottom: 5px;
  }
  
  .user {
    color: ${grey[700]};
    font-size: 12px;
  }
  
  .sending {
    margin-top: 5px;
    font-size: 12px;
    color: ${grey[700]};
    
    span {
      color: ${grey[900]};
    }
  }
  
  .union {
    margin-top: 5px;
    font-size: 12px;
    color: ${red[900]};
  }
`;

function GroupToggle({name, children}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <h3 onClick={() => setOpen(!open)}>
        {name}
        <span className={'ml-10'}>{open ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}</span>
      </h3>
      {open && children}
    </>
  )
}


export default function OrderCreateUploadDocuments({formContext}) {
  const [groups, setGroups] = useState([]);
  const [items, addItem, deleteItemByPredicate] = useList((items) => formContext.setValue('files', items));

  useEffect(() => {
    axios.get('catalog/catalog-document').then(res => {
      setGroups(res.data.results);
    })
  }, []);

  const filterItems = (group) => {
    return _.filter(items, {group: group.id})
  }

  return (
    <>
      {groups.map(group =>
        <StyledGroup className={'mt-15'} key={group.id}>
          <GroupToggle name={group.name}>
            <div className={'mt-10'}>
              <UploadButton
                url={'order/uploaded-document'}
                data={{
                  group: group.id
                }}
                onUploaded={(data) => addItem(data)}
              />
            </div>

            {filterItems(group).map((item, index) =>
              <StyledUploadedDocumentItem key={index}>
                <div>
                  <div className={'name'}>
                    <FileLink
                      fileUrl={item.file}
                      fileName={item.file_name}
                      fileContentType={item.file_content_type}
                    />
                  </div>
                  <div>
                  </div>
                  <div className={'user'}>
                    <span>{item.user.short_name || item.user.username}</span>
                    <span className={'ml-10'}><DateTimeDisplay value={item.created} /></span>
                    {item.description && <span className={'ml-10'}>{item.description}</span>}
                  </div>
                </div>
                <div>
                  <IconButton size="small" onClick={() => deleteItemByPredicate({id: item.id})}>
                    <ClearIcon />
                  </IconButton>
                </div>
              </StyledUploadedDocumentItem>
            )}
          </GroupToggle>
        </StyledGroup>
      )}
    </>
  )
}